import { getAuthAxiosInstance as authAxios } from './axios';
import { NetworkConfig } from '../signing/types';
import { REACT_APP_BACKEND_URL } from '../utils/constants';

export const createNetworkConfig = async (config: NetworkConfig) => {
  return authAxios()?.post(
    `${REACT_APP_BACKEND_URL}/network-config`,
    config,
  );
};

export const getNetworkConfigs = async () => {
  return authAxios()?.get(`${REACT_APP_BACKEND_URL}/network-config`);
};

export const deleteNetworkConfig = async (id: string, confirm?: boolean) => {
  const query = confirm ? '?confirm=true' : '';
  return authAxios()?.delete(`${REACT_APP_BACKEND_URL}/network-config/${id}${query}`);
};
